<style lang="scss" scoped>
  @import '../../../sass/variables';

  ::v-deep .reportrange-text {
    display: inline;
    padding: .48rem .8rem;
  }

  ::v-deep .reportrange-text div {
    display: inline;
  }

  ::v-deep .daterangepicker .calendar-table table {
    table-layout: fixed;

    thead, tbody {
      th {
        color: $salesflow-font-extra-dark;
        font-family: "Inter";
        font-size: 0.875rem;
        font-weight: 400;
        line-height: 150%;
      }
    }
  }

  ::v-deep .daterangepicker .calendar-table th {
    padding: 5px;
  }

  ::v-deep .daterangepicker .calendars {
    flex-wrap: nowrap;
  }

  ::v-deep .daterangepicker .calendars .ranges {
    padding-left: 5px;
    padding-right: 5px;
  }

  ::v-deep .daterangepicker.opensright {
    top: 22px;
    left: 0px;
  }

  ::v-deep .daterangepicker.opensleft {
    top: 22px;
    right: 0px;
  }

  ::v-deep .daterangepicker.openscenter {
    top: 22px;
  }

  //
  //
  //
  //
  ::v-deep .daterangepicker.opensright {
    top: 40px;
  }

  ::v-deep .daterangepicker.opensleft {
    top: 40px;
  }

  ::v-deep .daterangepicker.openscenter {
    top: 40px;
  }

  ::v-deep .daterangepicker {
    border-radius: 20px;
    border: 1px solid #EAE6F1;

    .ranges {
      margin: 0;
      padding: 12px 18px 18px 12px;
      letter-spacing: -0.5px;
      border-top-left-radius: 20px;
      border-bottom-left-radius: 20px;
      background: $salesflow-outline-gray-light;
      color: $salesflow-purple-extra-dark;

      li {
        padding: 1px 8px;
        font-size: 1rem;
        line-height: 150%;
      }

      .active {
        background-color: #EAE6F0;
        color: $salesflow-font-dark;
      }
    }

    td {
      width: 36px;
      height: 24px;
      padding: 0;
      font-family: "Inter";
      font-size: 0.875rem;
      font-weight: 400;
      line-height: 150%;
    }

    td.active {
      background-color: $salesflow-purple-dark;
    }

    td.disabled {
      text-decoration: none;
      color: $salesflow-outline-gray-medium;
      background-color: transparent;
    }

    td.end-date {
      color: white;
      width: 18px !important;
      border-radius: 0 20px 20px 0;
    }

    td.start-date {
      color: white;
      width: 18px !important;
      border-radius: 20px 0 0 20px;
    }

    td.in-range:not(.active) {
      background-color: $salesflow-purple-extra-light;
    }
  }

  //
  //
  //
  //

  .input-group {
    white-space: nowrap;
  }

  input {
    border-color: transparent;
    background-color: transparent;
  }

  input:hover {
    cursor: pointer;
  }

  i.fa {
    margin-right: 2px;
  }

  .fa.fa-angle-down {
    margin-left: 5px;
  }

  /* themes */
  .default-theme ::v-deep .reportrange-text {
    border-color: transparent;
  }

  .readonly-theme ::v-deep .reportrange-text {
    display: block;
    color: $black;
    background-color: $salesflow-bg-content;
    height: 52px;
    border: 0;

    .input-group {
      line-height: 32px
    }
  }

  .button-theme ::v-deep .reportrange-text {
    font-size: .9rem;
    line-height: 1.2;
    border: none;
    vertical-align: middle;
  }

  .button-theme ::v-deep .reportrange-text input {
    text-align: center;
  }

  .modern-theme {
    &::v-deep .reportrange-text {
      padding: 12px 24px;
      border-radius: 14px;
      background: transparent;
      color: $salesflow-font-gray;
      border: 1px solid $salesflow-outline-gray-medium;

      input, input::placeholder {
        color: $salesflow-font-gray;
        font-size: 0.75rem;
        // letter-spacing: 0.22px;
        font-weight: 600;
      }

      .input-group {
        padding-left: 8px;
      }
    }

    &::v-deep .daterangepicker {
      &.opensleft {
        &:before {
          font-size: 16px;
          right: 19px;
        }

        &:after {
          font-size: 16px;
          right: 20px;
        }
      }
    }
  }
</style>

<template>
  <span :class="theme+'-theme'">
    <DateRangePicker
      :date-range="settings.daterange"
      :ranges="settings.ranges"
      :time-picker="settings.timePicker"
      :auto-apply="settings.autoApply"
      :locale-data="settings.locale"
      :max-date="settings.max"
      :class="customClass"
      :opens="position"
      :min-date="minDate"
      @update="update"
    >
      <div
        slot="input"
        slot-scope="picker"
      >
        <BInputGroup>
          <template slot="prepend"><i class="fa fa-calendar" /></template>
          <input
            type="text"
            :placeholder="placeholder"
            :name="name"
            :style="maxWidth"
            v-model="range"
            readonly="readonly"
          >
          <template slot="append"><i class="fa fa-angle-down" /></template>
        </BInputGroup>
      </div>
    </DateRangePicker></span>
</template>

<script>
import { BInputGroup } from 'bootstrap-vue';
import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import dayjs from '../../core/dayjs';

export default {
  components: {
    DateRangePicker,
    BInputGroup,
  },

  props: {
    value: null,

    name: null,

    placeholder: {
      type: String,
      default: 'Clique para selecionar...',
    },

    preset: {
      type: String,
      default: 'default',
    },

    theme: {
      type: String,
      default: 'default',
    },

    width: {
      type: Number,
      default: 0,
    },

    start: {
      type: Number,
      default: 6,
    },

    customClass: {
      type: String,
      default: '',
    },

    position: {
      type: String,
      default: 'center',
    },

    minDate: {
      type: Date,
      default: null,
    },
  },

  data () {
    return {
      range: this.value,

      settings: {
        timePicker: false,

        autoApply: true,

        ranges: null,

        max: null,

        daterange: {
          startDate: null,
          endDate: dayjs().toDate(),
        },

        locale: {
          daysOfWeek: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sab'],
          firstDay: 1,
        },
      },
    };
  },

  mounted () {
    this.render();
  },

  watch: {
    value (newVal, oldVal) {
      if (newVal != oldVal) {
        this.range = newVal;
      }
    },

    preset () {
      this.render();
    },
  },

  computed: {
    maxWidth () {
      return `max-width: ${this.width === 0 ? 'none' : `${this.width}px`}`;
    },
  },

  methods: {
    render () {
      const { ranges, start, max } = this.getPreset();

      this.settings.ranges = ranges;
      this.settings.daterange.startDate = dayjs().subtract(start, 'days').toDate();
      this.settings.max = max;
    },

    getPreset () {
      const {
        __,
        preset,
      } = this;

      const now = dayjs();
      const today = now.toDate();

      if (preset === 'default') {
        return {
          ranges: {
            [__('Hoje')]: [today, today],
            [__('Ontem')]: [now.subtract(1, 'days').toDate(), now.subtract(1, 'days').toDate()],
            [__('Últimos 7 dias')]: [now.subtract(6, 'days').toDate(), today],
            [__('Últimos 30 dias')]: [now.subtract(29, 'days').toDate(), today],
            [__('Mês atual')]: [now.startOf('month').toDate(), now.endOf('month').toDate()],
            [__('Mês anterior')]: [now.subtract(1, 'month').startOf('month').toDate(), now.subtract(1, 'month').endOf('month').toDate()],
          },
          start: this.start,
          max: now.toDate(),
        };
      }

      if (preset === 'report') {
        return {
          ranges: {
            [__('Últimos 30 dias')]: [now.subtract(29, 'days').toDate(), today],
            [__('Mês atual')]: [now.startOf('month').toDate(), now.endOf('month').toDate()],
            [__('Mês anterior')]: [now.subtract(1, 'month').startOf('month').toDate(), now.subtract(1, 'month').endOf('month').toDate()],
            [__('Últimos 90 dias')]: [now.subtract(89, 'days').toDate(), today],
            [__('Últimos 180 dias')]: [now.subtract(179, 'days').toDate(), today],
          },
          start: this.start,
          max: null,
        };
      }

      if (preset === 'future') {
        return {
          ranges: {
            [__('Últimos 30 dias')]: [now.subtract(29, 'days').toDate(), today],
            [__('Ontem')]: [now.subtract(1, 'days'), now.subtract(1, 'days').toDate()],
            [__('Hoje')]: [today, today],
            [__('Próximos 7 dias')]: [today, now.add(6, 'days').toDate()],
            [__('Próximos 30 dias')]: [today, now.add(29, 'days').toDate()],
          },
          start: 0,
          max: null,
        };
      }

      if (preset === 'deals-board') {
        return {
          ranges: {
            [__('Últimos 30 dias')]: [now.subtract(29, 'days').toDate(), today],
            [__('Últimos 15 dias')]: [now.subtract(14, 'days').toDate(), today],
            [__('Últimos 7 dias')]: [now.subtract(6, 'days').toDate(), today],
            [__('Ontem')]: [now.subtract(1, 'days').toDate(), now.subtract(1, 'days').toDate()],
            [__('Hoje')]: [today, today],
          },
          start: 0,
          max: null,
        };
      }

      throw new Error(`Undefined preset "${preset}"`);
    },

    update (picker) {
      this.range = `${dayjs(picker.startDate).format('DD-MM-YYYY')} > ${dayjs(picker.endDate).format('DD-MM-YYYY')}`;

      this.$emit('input', this.range);

      // if (this.element.is('input')) {
      //   this.element.val(value);
      //   this.element.trigger('change');
      // }
    },
  },
};
</script>
